// extracted by mini-css-extract-plugin
module.exports = {"frame":"Card_frame__3XiTB","content":"Card_content__FQV8q","img":"Card_img__3Yue1","frame__inner":"Card_frame__inner__y6sKa"};